import moment from 'moment'

export function CapitalizeFirstLetter(string) {

    if (string === null) return string
    if (string === undefined) return string
    if (string.length === 0) return string

    return string.charAt(0).toUpperCase() + string.slice(1);
    
}

export function GetWorkoutTemplateNameFromKey(string) {

    switch(string){
        case "strength-session-a": return "Strength Session A";
        case "strength-session-b": return "Strength Session B";
        case "mobility-a": return "Mobility A";
        case "mobility-b": return "Mobility B";
        case "rest": return "Rest";
        default: return string 
    }

}

export function GetStrengthSessionPhaseNamesFromPhaseIndex(phaseIndex) {

    const phaseNames = [
        "Warm Up", 
        "Prep", 
        "Main 1", 
        "Main 2", 
        "Accessory"
    ]

    return phaseNames[phaseIndex]

}

export function GetProgressionLevelName(progressionLevel) {

    const progressionLevelNames = {
        '0': 'Beginner',
        '1': 'Foundational',
        '2': 'Intermediate',
        '3': 'Progressed',
        '4': 'Advanced'
    }

    return progressionLevelNames[progressionLevel]

}

export function GetDifficultyTextFromValue(difficuly) {

    const difficultyIndex = parseInt(difficuly) + 2

    const difficultyTexts = ["Too Easy", "A Little Easy", "Neutral", "A Little Difficult", "Too Difficult"]

    return difficultyTexts[difficultyIndex]

}

export function GetMovementDifficultyScaleText(difficulty) {

    switch (difficulty){
        case -2: return "Too Easy"
        case -1: return "Easy"
        case 0: return "Neutral"
        case 1: return "Hard"
        case 2: return "Too Hard"
        default:
            console.warn(difficulty + " is not a valid difficulty value!! Defaulting to neutral icon")
            return "Neutral"
    }

}

export function GetLoadDifficultyScaleText(difficulty) {

    switch (difficulty){
        case -2: return "Too Light"
        case -1: return "Light"
        case 0: return "Neutral"
        case 1: return "Heavy"
        case 2: return "Too Heavy"
        default:
            console.warn(difficulty + " is not a valid difficulty value!! Defaulting to neutral icon")
            return "Neutral"
    }

}

export const GetAthleteInvitePlainText = (organizationName, organizationCode) => {

    // DO NOT ADD TABS TO THIS TEXT
    // IT WILL EFFECT THE COPYING TO CLIPBOARD

    return (
`You have been invited to join ${organizationName} on Kinesis!\n
If you do not have a Kinesis account yet:\n
Step 1: Get the app by going to https://t0ntp.app.link/wBY0kmr05Sb on your phone
Step 2: On the login screen, select "Sign Up"
Step 3: Select the option "Sign Up With Coach"
Step 4: Enter your invite code: ${organizationCode}
Step 5: Finish setting up your account
Step 6: Get Strong! 💪\n
If you already have a Kinesis account:\n
Step 1: Login to your account
Step 2: Open the sidebar menu using the button at the top left of the screen
Step 3: Select "Membership"
Step 4: Select "Join an Organization"
Step 5: Enter organization code: ${organizationCode}
Step 6: Get Strong! 💪\n
If you have any questions, please contact us at support@kinesisintegrated.com`
    )

}

export const GetAthleteInviteToSignUpWithCoachPlainText = (coachFirstName, coachLastName, organizationName, coachInviteSignUpCode) => {

    // DO NOT ADD TABS TO THIS TEXT
    // IT WILL EFFECT THE COPYING TO CLIPBOARD

    return (
`Your coach ${coachFirstName} ${coachLastName} has invited you to join ${organizationName} on Kinesis!\n
They have already created an account for you!\n
Here is how to access it:\n
Step 1: Get the app by going to https://t0ntp.app.link/wBY0kmr05Sb on your phone
Step 2: On the login screen, select "Sign Up"
Step 3: Select the option "Sign Up With Coach"
Step 4: Enter your unique invite code: ${coachInviteSignUpCode}
Step 5: Finish setting up your account
Step 6: Get Strong! 💪\n
If you have any questions, please contact us at support@kinesisintegrated.com`
    )

}

export const GetCoachInvitePlainText = (organizationName, organizationCode) => {

    // DO NOT ADD TABS TO THIS TEXT
    // IT WILL EFFECT THE COPYING TO CLIPBOARD

    return (
`You have been invited to join ${organizationName} as a coach on Kinesis!\n
Step 1: Go to dashboard by going to https://coach.kinesisintegrated.com on your desktop
Step 2: During onboarding, enter organization code: ${organizationCode}
Step 3: Get Strong! 💪\n
If you have any questions, please contact us at support@kinesisintegrated.com`
    )

}

export function GetDateTimeDisplay(dateString) {

    const timestamp = moment.utc(dateString).local()
    const now = moment().utc().local()

    if (timestamp.year() === now.year()) return timestamp.format("MMMM Do hh:mm A");
    
    return timestamp.format("MMMM Do, YYYY hh:mm A");

}